<template>
  <div>
    <DxForm
      label-mode="static"
      label-location="top"
    >
      <DxGroupItem
        css-class="content-devx"
        :caption="readOnly ? 'PROYECTO' : $t('registerProject.title_groupItem_registerProject')"
        :col-count="2"
      >
        <DxSimpleItem
          name="nameProject"
          :data-field="$t('registerProject.register_project_name')"
          :editor-options="{
            value: newProject.name,
            onValueChanged: onChangeNameProject,
            readOnly: readOnly,
            placeholder: currentProject === '626964f0226c811a55568262' && !readOnly
              ? 'Agregue un nuevo nombre' : ''
          }"
        />
        <DxSimpleItem
          name="size"
          :data-field="$t('registerProject.register_project_size_open_air')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.area,
            onValueChanged: onChangeSize,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="province"
          :data-field="$t('registerProject.register_project_province')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: provinces,
            value: newProject.province,
            displayExpr: 'value',
            valueExpr: 'id',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeProvince,
            placeholder: '',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          :key="itemsClimateKey"
          name="stationClimate"
          :data-field="$t('registerProject.register_project_stationClimate')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: itemsClimate,
            displayExpr: 'source',
            valueExpr: 'idByType',
            value: selectedDataType === 'DB'
              ? newProject.climate_id
              : `${newProject.weather_source}_${selectedDataType}`,
            onValueChanged: onChangeStationClimate,
            searchEnabled: devicePlatform === 'web',
            placeholder: '',
            readOnly: readOnly
          }"
        />
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx"
        :caption="$t('registerProject.title_groupItem_crop')"
        :col-count="2"
      >
        <DxSimpleItem
          name="crop"
          :data-field="$t('registerProject.register_project_crop')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: listCropEx,
            displayExpr: 'name',
            valueExpr: 'id',
            value: newProject.cultive ? newProject.cultive.crop_id : null,
            onValueChanged: onChangeCrop,
            readOnly: readOnly,
            placeholder: ''
          }"
        />
        <DxSimpleItem
          name="dateTransplanting"
          :data-field="
            $t('registerProject.registerProjectOpenAir.register_project_dateTransplanting')"
          editor-type="dxDateBox"
          :editor-options="{
            value: newProject.cultive ? newProject.cultive.date_init : null,
            displayFormat: 'dd/MM/yyyy',
            onValueChanged: onChangeDateTransplanting,
            max: newProject.cultive && newProject.cultive.date_end
              ? newProject.cultive.date_end : null,
            dateOutOfRangeMessage: 'La fecha está fuera de rango',
            readOnly: readOnly,
          }"
        />

        <DxSimpleItem
          name="DensityPlantation"
          :data-field="
            $t('registerProject.registerProjectOpenAir.register_project_densityPlantation')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.cultive ? newProject.cultive.density_plantation : null,
            onValueChanged: onChangeDensityPlantation,
            readOnly: readOnly,
            message: 'Custom'
          }"
        />
        <DxSimpleItem
          name="end_date_crop"
          :data-field="$t('registerProject.register_project_end_date_crop')"
          editor-type="dxDateBox"
          :editor-options="{
            value: newProject.cultive ? newProject.cultive.date_end: null,
            displayFormat: 'dd/MM/yyyy',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeEndDateCrop,
            min: newProject.cultive && newProject.cultive.date_init
              ? newProject.cultive.date_init : null,
            readOnly: readOnly
          }"
        />
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx"
        :caption="$t('registerProject.registerProjectOpenAir.title_groupItem_irrigation')"
        :col-count="2"
      >
        <DxGroupItem
          :col-count="1"
        >
          <DxSimpleItem
            name="typeIrrigation"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_typeIrrigation')"
            :col-span="2"
            editor-type="dxSelectBox"
            :editor-options="{
              items: itemsTypesIrrigation,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.irrigation ? newProject.irrigation.typeIrrigation : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeTypeIrrigation,
              placeholder: '',
              readOnly: readOnly
            }"
          />

          <DxSimpleItem
            v-if="isLocated"
            name="isLocatedDistanceBetweenLines"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_distanceBetweenLines')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.distanceBetweenLines : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeDistanceBetweenLines,
              placeholder: '',
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            v-if="isLocated"
            name="isLocatedDistanceBetweenDrippers"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_distanceBetweenDrippers')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              items: floor,
              value: newProject.irrigation ? newProject.irrigation.distanceBetweenDrippers : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeDistanceBetweenDrippers,
              placeholder: '',
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            v-if="isArea"
            name="systemEfficiency"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_systemEfficiency')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.systemEfficiency : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeSystemEfficiency,
              placeholder: '',
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            v-if="isArea"
            name="irrigationWater"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_irrigationWater')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.irrigationWater : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeIrrigationWater,
              placeholder: '',
              readOnly: readOnly,
              hint: 'Debe introducir 0 si no se conoce el valor de N agua de riego'
            }"
          />
        </DxGroupItem>
        <DxGroupItem
          :col-count="1"
        >
          <DxSimpleItem
            v-if="isLocated"
            name="isLocatedDropperFlow"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_dropperFlowRate')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.dropperFlow : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeDropperFlow,
              placeholder: '',
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            v-if="isLocated"
            name="isLocatedSystemEfficiency"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_systemEfficiency')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.systemEfficiency : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeSystemEfficiency,
              placeholder: '',
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            v-if="isLocated"
            name="isLocatedirrigationWater"
            :data-field="
              $t('registerProject.registerProjectOpenAir.register_project_irrigationWater')"
            :col-span="2"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.irrigation ? newProject.irrigation.irrigationWater : null,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeIrrigationWater,
              placeholder: '',
              readOnly: readOnly,
              hint: 'Debe introducir 0 si no se conoce el valor de N agua de riego'
            }"
          />
        </DxGroupItem>
      </DxGroupItem>
    </DxForm>
    <DxPopUpFloor />
    <DxPopUpStation
      v-if="selection !== 'GreenHouse'"
      :new-project-o-a="newProject"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
} from 'devextreme-vue/form';
import { locale } from 'devextreme/localization';
import DxPopUpFloor from '../popUpFloor/index.vue';
import DxPopUpStation from '../registerProjectGreenhouse/popUpStation/index.vue';
import EventBus from '../../../js/event-bus';
import { DEVICE_PLATFORM } from '../../../js/constants';

export default {
  name: 'RegisterProjectOpenAir',
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxPopUpFloor,
    DxPopUpStation,
  },
  props: {
    listCrop: {
      type: Array,
      default: () => [],
    },
    provinces: {
      type: Array,
      default: () => [],
    },
    keyName: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemsClimate: [],
      itemsTypesIrrigation: [{ id: 'SUPERFICIE', name: 'SUPERFICIE (ASPERSIÓN)' }, { id: 'LOCALIZADO', name: 'LOCALIZADO' }],
      backdoor: 0,
      itemsClimateKey: 0,
      selectedDataType: 'MEAN_YEAR',
      devicePlatform: DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectOpenAir', ['newProject', 'stationClimate', 'cropMedium', 'methodPlantation', 'floor',
      'analysis_recient', 'listCropEx', 'irrigation', 'climate']),
    ...mapState('Database', ['currentProject']),
    isLocated() {
      this.backdoor;
      if (this.newProject.irrigation) {
        return this.newProject.irrigation.typeIrrigation === 'LOCALIZADO';
      }
      return false;
    },
    isArea() {
      this.backdoor;
      if (this.newProject.irrigation) {
        return this.newProject.irrigation.typeIrrigation === 'SUPERFICIE';
      }
      return false;
    },
  },
  created() {
    locale('es');
  },
  async beforeMount() {
    EventBus.$on('selected-station-open-air', (res) => {
      if (res.id) {
        this.itemsClimate.push({
          id: res.id,
          idByType: res.id,
          source: `${res.source} (Base de datos)`,
          data_type: 'DB',
        });
        this.itemsClimateKey += 1;
        this.selectedDataType = 'DB';
        this.setStation(null);
        this.setClimateId(res.id);
        this.itemsClimateKey += 1;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('selected-station-open-air');
  },
  mounted() {
    if (this.currentProject === '626964f0226c811a55568262' && !this.readOnly) {
      this.setNameProject('');
    } else {
      this.setNameProject(this.newProject.name);
    }
    if (this.newProject.density !== null) {
      this.newProject.density_plantation = this.newProject.density;
    }
    if (this.newProject.weather_source_type) {
      this.selectedDataType = this.newProject.weather_source_type;
    } else if (this.newProject.climate_id) {
      this.selectedDataType = 'DB';
    } else {
      this.selectedDataType = 'MEAN_YEAR';
    }
    if (this.newProject.irrigation.irrigation_open_air) {
      this.newProject.irrigation.typeIrrigation = this.newProject.irrigation.irrigation_open_air;
      this.backdoor += 1;
    }
    if (this.newProject.irrigation
    && (this.newProject.irrigation.line_distance
            || this.newProject.irrigation.line_distance === 0)) {
      this.newProject.irrigation.distanceBetweenLines = this.newProject.irrigation.line_distance;
    }
    if (this.newProject.irrigation
    && (this.newProject.irrigation.drip_distance
            || this.newProject.irrigation.drip_distance === 0)) {
      this.newProject.irrigation.distanceBetweenDrippers = this.newProject.irrigation.drip_distance;
    }
    if (this.newProject.irrigation
    && (this.newProject.irrigation.efficiency || this.newProject.irrigation.efficiency === 0)) {
      this.newProject.irrigation.systemEfficiency = this.newProject.irrigation.efficiency;
    }
    if (this.newProject.irrigation
        && (this.newProject.irrigation.n_water || this.newProject.irrigation.n_water === 0)) {
      this.newProject.irrigation.irrigationWater = this.newProject.irrigation.n_water;
    }
    if (this.newProject.irrigation
        && (this.newProject.irrigation.caudal || this.newProject.irrigation.caudal === 0)) {
      this.newProject.irrigation.dropperFlow = this.newProject.irrigation.caudal;
    }
    this.setData();
  },
  methods: {
    async setData() {
      try {
        this.$f7.preloader.show();
        this.backdoor += 1;
        await this.fetchProvinces();
        if (this.profile && this.profile.province && !this.newProject.province) {
          this.setProvince(this.profile.province);
          await this.fetchDatabaseClimate(this.profile.province);
        } else if (this.newProject.province) {
          await this.fetchDatabaseClimate(this.newProject.province);
        } else {
          await this.fetchDatabaseClimate();
        }
        const prepareItemsClimate = [...this.stationClimate];
        if (this.climate && this.climate.siar_stations
            && this.climate.siar_stations.data
            && this.climate.siar_stations.data.length) {
          this.climate.siar_stations.data.forEach((item) => {
            prepareItemsClimate.push({
              id: item.code,
              idByType: `${item.code}_MEAN_YEAR`,
              source: `${item.name} (Año medio)`,
              data_type: 'MEAN_YEAR',
            });
            prepareItemsClimate.push({
              id: item.code,
              idByType: `${item.code}_REAL_TIME`,
              source: item.name,
              data_type: 'REAL_TIME',
            });
          });
        }
        if (this.climate && this.climate.db_climate
            && this.climate.db_climate.length) {
          this.climate.db_climate.forEach((item) => {
            if (item.project_type === 'EX') {
              prepareItemsClimate.push({
                id: item.id,
                idByType: item.id,
                source: `${item.source} (Base de datos)`,
                data_type: 'DB',
              });
            }
          });
        }
        this.itemsClimate = prepareItemsClimate;
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onChangeNameProject(e) {
      this.setNameProject(e.value);
    },
    onChangeSize(e) {
      this.setArea(e.value);
    },
    async onChangeProvince(e) {
      try {
        this.$f7.preloader.show();
        this.setProvince(e.value);
        await this.fetchDatabaseClimate(e.value);
        const prepareItemsClimate = [...this.stationClimate];
        if (this.climate && this.climate.siar_stations
            && this.climate.siar_stations.data
            && this.climate.siar_stations.data.length) {
          this.climate.siar_stations.data.forEach((item) => {
            prepareItemsClimate.push({
              id: item.code,
              idByType: `${item.code}_MEAN_YEAR`,
              source: `${item.name} (Año medio)`,
              data_type: 'MEAN_YEAR',
            });
            prepareItemsClimate.push({
              id: item.code,
              idByType: `${item.code}_REAL_TIME`,
              source: item.name,
              data_type: 'REAL_TIME',
            });
          });
        }
        if (this.climate && this.climate.db_climate
            && this.climate.db_climate.length) {
          this.climate.db_climate.forEach((item) => {
            if (item.project_type === 'EX') {
              prepareItemsClimate.push({
                id: item.id,
                idByType: item.id,
                source: `${item.source} (Base de datos)`,
                data_type: 'DB',
              });
            }
          });
        }
        this.itemsClimate = prepareItemsClimate;
        this.itemsClimateKey += 1;
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onChangeStationClimate(e) {
      if (typeof e.event !== 'undefined') {
        const findItem = this.itemsClimate.find(((item) => item.idByType === e.value));
        if (findItem) {
          if (findItem.id === 'Añadir') {
            this.setEnabledPopUpStation(true);
            this.setStation(null);
            this.setClimateId(null);
            this.setStationType(null);
            this.itemsClimateKey += 1;
          } else {
            this.selectedDataType = findItem.data_type;
            if (findItem.data_type === 'DB') {
              this.setStation(null);
              this.setClimateId(findItem.id);
            } else {
              this.setStation(findItem.id);
              this.setStationType(findItem.data_type);
              this.setClimateId(null);
            }
          }
        }
      }
    },
    onChangeCrop(e) {
      this.setCrop(e.value);
      const crop = this.listCropEx.find((item) => item.id === e.value);
      if (crop && crop.root_deep) {
        this.setSizeGreenHouse(crop.root_deep);
      }
    },
    onChangeDateTransplanting(e) {
      this.setDateTransplanting(e.value);
    },
    onChangeDensityPlantation(e) {
      this.setDensityPlantation(e.value);
    },
    onChangeEndDateCrop(e) {
      this.setDateEndCrop(e.value);
    },
    onChangeTypeIrrigation(e) {
      if (e.event) {
        this.setTypeIrrigation(e.value);
        this.backdoor += 1;
      }
    },
    onChangeDropperFlow(e) {
      this.setDropperFlow(e.value);
    },
    onChangeDistanceBetweenLines(e) {
      this.setDistanceBetweenLines(e.value);
    },
    onChangeDistanceBetweenDrippers(e) {
      this.setDistanceBetweenDrippers(e.value);
    },
    onChangeSystemEfficiency(e) {
      this.setSystemEfficiency(e.value);
    },
    onChangeIrrigationWater(e) {
      this.setIrrigationWater(e.value);
    },
    ...mapActions('ProjectOpenAir', ['setNameProject', 'setSizeGreenHouse', 'setArea', 'setProvince', 'setStation',
      'setStationType', 'setCrop', 'setDateTransplanting', 'setCropMedium', 'setDateEndCrop', 'setEnabledPopUpFloor',
      'setTypeIrrigation', 'setDropperFlow', 'setDistanceBetweenLines', 'setDistanceBetweenDrippers',
      'setSystemEfficiency', 'setIrrigationWater', 'setDensityPlantation', 'fetchDatabaseClimate', 'setClimateId']),
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpStation', 'fetchProvinces']),
  },
};
</script>

<style>
@import "../registerProjectGreenhouse/registerProject.scss";
</style>
